<template>
    <ul class="list-group mb-1">
        <li @click="chooseImage" class="list-group-item picselect" :class="[image?'bg-green':'']">
            <img class="img-thumbnail" :src="imageurl" width="35" height="35"/>
            <span class="d-inline-block ml-4">Bild wählen</span>
            <input :required="required" @change="onSelectFile" type="file" name="picture[]" class="d-none" ref="fileInput" accept="image/*"/>
        </li>
    </ul>
</template>

<script>
    import imageResizer from "../../libs/imageResizer";

    export default {
        name: "image-file-select",

        data: () => ({
            imageurl: 'https://placehold.it/35x35?text=NoPic',
            image: false
        }),

        props: {
            required: false,
            name: {
                type: String,
                required: true
            }
        },

        methods: {
            chooseImage () {
                this.$refs.fileInput.click()
            },

            onSelectFile () {
                const input = this.$refs.fileInput
                const files = input.files

                const _this = this

                if (files && files[0]) {

                    // todo: delete old way
                    // const reader = new FileReader
                    // reader.onload = e => {
                    //     this.imageurl = e.target.result
                    //     this.image = true
                    //
                    //     this.$emit('setimage', { name:this.name, value:e.target.result })
                    // }
                    // reader.readAsDataURL(files[0])

                    imageResizer({
                        file: files[0],
                        maxSize: 1600
                    }).then(function (resizedImage) {
                        _this.imageurl = resizedImage
                        _this.image = true
                        _this.$emit('setimage', { name:_this.name, value:resizedImage })
                    }).catch(function (err) {
                        console.error(err);
                    })

                }
            }
        }
    }
</script>

<style scoped>
    .picselect:hover {
        cursor: pointer;
        background: #F1F1F1;
    }

    .img-thumbnail {
        padding: .1rem;
        height: 35px;
    }

    .img-thumbnail:hover {
        transform: scale(2.5);
        transition: all 200ms;
    }

    .list-group-item {
        position: relative;
        display: block;
        padding: 0.5rem .7rem;
        margin-bottom: -1px;
        border: 1px solid rgba(0,0,0,.125);
    }
</style>